import React from "react";
import { Typography } from "@mui/material";

import Loading from "./Loading";
import ModalWrapper from "../modals/modalWrapper/ModalWrapper";

const LoadingModal = (props) => {
  const { open = true, loadingText = "Loading..." } = props;

  return (
    <ModalWrapper show={open} showTitle={false} maxWidth="xs">
      <div className="d-flex flex-column justify-center">
        <Loading height={80} width="400px" />
        {loadingText && (
          <Typography variant="h6" style={{ textAlign: "center" }}>
            {loadingText}
          </Typography>
        )}
      </div>
    </ModalWrapper>
  );
};

export default LoadingModal;
